var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournalElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398,0.9H114c-7.8,0-14.2,6.3-14.2,14.2v481.8c0,7.8,6.3,14.2,14.2,14.2h284c7.8,0,14.2-6.3,14.2-14.2V15.1 C412.2,7.3,405.8,0.9,398,0.9z M383.8,29.3v341.2H128.2V29.3H383.8z M128.2,482.7v-83.9h255.6v83.9H128.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.1,149.5H199c-7.8,0-14.2-6.3-14.2-14.2s6.3-14.2,14.2-14.2h114.1c7.8,0,14.2,6.3,14.2,14.2S320.9,149.5,313.1,149.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.1,287.7H199c-7.8,0-14.2-6.3-14.2-14.2s6.3-14.2,14.2-14.2h114.1c7.8,0,14.2,6.3,14.2,14.2S320.9,287.7,313.1,287.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalElement);
export default __webpack_public_path__ + "static/media/journal-element.7858d067b0ad32e2da5b71a660b317b5.svg";
export { ForwardRef as ReactComponent };